import { Routes, Route, Navigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import AppShell from "./components/AppShell";
import RequireAccess from "./components/RequireAccess";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import AssessmentsPage from "./pages/AssessmentsPage";
import NewAssessmentPage from "./pages/NewAssessmentPage";
import AssessmentDetailPage from "./pages/AssessmentDetailPage";
import EvaluatePage from "./pages/EvaluatePage";
import AuditPage from "./pages/AuditPage";
import AdminPage from "./pages/AdminPage";
import TakePage from "./pages/candidate/TakePage";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const isAuthed = useIsAuthenticated();
  const { inProgress } = useMsal();
  // MSAL reports unauthenticated during startup, even with a cached account.
  // Wait before redirecting so a direct page link keeps its intended route.
  if (inProgress === InteractionStatus.Startup || inProgress === InteractionStatus.HandleRedirect) {
    return <p role="status" className="p-6 text-sm text-slate-500">Checking sign-in...</p>;
  }
  return isAuthed ? <>{children}</> : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      {/* Candidate-facing — token-gated, NO sign-in */}
      <Route path="/take/:token" element={<TakePage />} />

      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <AppShell>
              <Routes>
                <Route path="/" element={<AssessmentsPage />} />
                <Route path="/new" element={<NewAssessmentPage />} />
                <Route path="/assessment/:id" element={<AssessmentDetailPage />} />
                <Route path="/evaluate" element={<EvaluatePage />} />
                <Route path="/audit" element={<RequireAccess area="audit"><AuditPage /></RequireAccess>} />
                <Route path="/admin" element={<RequireAccess area="admin"><AdminPage /></RequireAccess>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppShell>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
